export default __webpack_public_path__ + "static/media/fireplace.936b65a6.svg";